module.exports = __webpack_public_path__ + "static/other/gameTicketTaker.be4418fc.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameTicketTaker.json
// module id = 2604
// module chunks = 0